import { render, staticRenderFns } from "./Test3.vue?vue&type=template&id=18545f19&scoped=true&"
import script from "./Test3.vue?vue&type=script&lang=js&"
export * from "./Test3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18545f19",
  null
  
)

export default component.exports